<div class="modal-content">
  <div class="modal-header">
    <h4 class="title is-size-4" translate="letterUpload.title"></h4>
  </div>
  <div
    class="modal-body is-flex is-align-items-center is-flex-direction-column"
  >
    <p
      class="has-text-grey mb-4"
      [innerHtml]="'letterUpload.subtitle' | translate"
    ></p>

    <button
      class="mb-4"
      type="button"
      (click)="download()"
      fino-button
      label="letterUpload.download"
    ></button>

    @if (pdfPreviewAsBase64) {
      <div class="pdf-viewer mb-6">
        <ng2-pdfjs-viewer
          viewerId="JobPdfViewer"
          [showSpinner]="false"
          pagemode="thumbs"
          [pdfSrc]="pdfPreviewAsBase64"
        ></ng2-pdfjs-viewer>
      </div>
    }
  </div>
  <div class="modal-footer">
    <div class="is-flex is-centered mt-4">
      <button
        [primary]="true"
        type="button"
        class="has-text-weight-bold mr-1"
        (click)="submit()"
        fino-button
        label="letterUpload.submit"
      ></button>

      <button
        type="button"
        (click)="abort()"
        class="ml-1"
        fino-button
        label="letterUpload.abort"
      ></button>
    </div>
  </div>
</div>
